import { generateActions } from "../generateActions";
import { eLichThiSinhVienActionsObj } from './../../action-types/tct/ILichThiSinhVienActions';

export const lichThiSinhVienActions = {
    ...generateActions(eLichThiSinhVienActionsObj, "LICH_THI_SINH_VIEN"),

}